// create a throttled version of a function
//  (only called once every specified number of milliseconds)
export const throttle = (func: Function, delay: number, beforeTimeout?: boolean) => {
  let inProgress = false
  return (...args) => {
    if (inProgress) return
    inProgress = true
    if (beforeTimeout) func(...args)
    setTimeout(() => {
      if (!beforeTimeout) func(...args)
      inProgress = false
    }, delay)
  }
}

// create a debounced version of a function
// (only called after it hasn't been called in the past specified number of milliseconds)
export const debounce = (func: Function, delay: number, beforeTimeout?: boolean) => {
  let timeout
  return (...args) => {
    const after = () => {
      timeout = null
      if (!beforeTimeout) func(...args)
    }
    const callNow = beforeTimeout && !timeout
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(after, delay)
    if (callNow) func(...args)
  }
}

// curried map
export const map = (fn) => (mappable) => mappable.map(fn)

// curried filter
export const filter = (fn) => (mappable) => mappable.filter(fn)
